export default "__VITE_ASSET__047ce808__"